(function () {
  document.querySelectorAll('.product-express').forEach(initProductExpress);

  function initProductExpress(root) {
    const variantSelects = root.querySelector('variant-selects');
    const variantsScript = root.querySelector('[data-express-variants]');
    const optionNamesScript = root.querySelector('[data-express-option-names]');
    const config = root.querySelector('[data-express-config]');
    if (!variantSelects || !variantsScript || !optionNamesScript || !config) return;

    const variants = JSON.parse(variantsScript.textContent);
    const optionNames = JSON.parse(optionNamesScript.textContent);
    const topperVariantId = config.dataset.topperVariantId;

    const priceEl = root.querySelector('[data-express-price]');
    const variantIdInput = root.querySelector('.product-express__variant-id-fallback');
    const flavorInfo = root.querySelector('[data-express-flavor-info]');
    const flavorPhoto = root.querySelector('[data-express-flavor-photo]');
    const flavorPhotoImage = root.querySelector('[data-express-flavor-image]');
    const dateInput = root.querySelector('[data-express-date-input]');
    const form = root.querySelector('.product-express__form form');
    const submitButton = root.querySelector('[data-express-submit]');
    const topperCheckbox = root.querySelector('[data-express-topper]');
    const errorWrapper = root.querySelector('.product-express__error-message-wrapper');
    const errorMessage = root.querySelector('.product-express__error-message');
    const soldOutNote = root.querySelector('[data-express-sold-out]');
    const quantityInput = root.querySelector('[data-quantity-input]');
    const quantityDecrease = root.querySelector('[data-quantity-decrease]');
    const quantityIncrease = root.querySelector('[data-quantity-increase]');

    if (quantityInput && quantityDecrease && quantityIncrease) {
      quantityDecrease.addEventListener('click', () => {
        quantityInput.value = Math.max(1, (parseInt(quantityInput.value, 10) || 1) - 1);
      });
      quantityIncrease.addEventListener('click', () => {
        quantityInput.value = (parseInt(quantityInput.value, 10) || 1) + 1;
      });
    }

    // Lead time counts Monday to Friday only: Saturday is a pickup day, not a
    // production day (Regulamin § 2). Sunday is the one day nothing can be
    // collected either. The number of days is editable per section in the
    // theme customizer (min_business_days).
    const CLOSED_WEEKDAY = 0;

    function isBusinessDay(date) {
      const day = date.getDay();
      return day !== 0 && day !== 6;
    }

    function toDateInputValue(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return year + '-' + month + '-' + day;
    }

    function earliestPickupDate() {
      const parsedDays = parseInt(config.dataset.minBusinessDays, 10);
      const businessDays = isNaN(parsedDays) ? 1 : parsedDays;
      const date = new Date();
      date.setHours(0, 0, 0, 0);
      let added = 0;
      while (added < businessDays) {
        date.setDate(date.getDate() + 1);
        if (isBusinessDay(date)) added++;
      }
      return date;
    }

    const dateError = root.querySelector('[data-express-date-error]');
    const CLOSED_MESSAGE = dateError ? dateError.textContent.trim() : '';

    // The minimum used to be enforced by the input's "min" attribute alone.
    // Chrome and Firefox refuse to submit a form whose date falls below it, so
    // the lead time held; Safari submits anyway and a cake with a 24 hour lead
    // time could be ordered for the same day. The rule is therefore checked
    // here too, and the attribute is left in place only to grey the earlier
    // days out in the picker.
    function pickupDateIssue() {
      if (!dateInput || !dateInput.value) return null;
      const [year, month, day] = dateInput.value.split('-').map(Number);
      const selected = new Date(year, month - 1, day);
      if (isNaN(selected.getTime())) return 'Wybierz poprawną datę odbioru.';
      if (selected.getDay() === CLOSED_WEEKDAY) return CLOSED_MESSAGE;
      const earliest = earliestPickupDate();
      if (selected < earliest) {
        return 'Najwcześniejszy możliwy termin odbioru to ' + earliest.toLocaleDateString('pl-PL') + '.';
      }
      return null;
    }

    function showDateIssue(message) {
      if (!dateError) return;
      dateError.textContent = message || CLOSED_MESSAGE;
      dateError.hidden = !message;
    }

    if (dateInput) {
      const minDate = earliestPickupDate();
      dateInput.min = toDateInputValue(minDate);

      dateInput.addEventListener('change', () => {
        if (!dateInput.value) {
          showDateIssue(null);
          return;
        }
        const issue = pickupDateIssue();
        // A Sunday is cleared, as it always was; a date that is merely too
        // early keeps its value so the customer can see what they picked while
        // they correct it.
        if (issue === CLOSED_MESSAGE) dateInput.value = '';
        showDateIssue(issue);
      });
    }

    function getSelectedOptions() {
      const selected = {};
      variantSelects.querySelectorAll('fieldset').forEach((fieldset) => {
        // Sizes are a dropdown; the other options are rows of radio buttons.
        const select = fieldset.querySelector('select[data-option-name]');
        if (select) {
          selected[select.dataset.optionName] = select.value;
          return;
        }
        const checked = fieldset.querySelector('input:checked');
        if (!checked) return;
        const name = checked.dataset.optionName;
        if (name) selected[name] = checked.value;
      });
      return selected;
    }

    function findMatchingVariant() {
      const selected = getSelectedOptions();
      return variants.find((variant) => {
        return optionNames.every((optionName, index) => {
          const key = 'option' + (index + 1);
          if (!(optionName in selected)) return true;
          return variant[key] === selected[optionName];
        });
      });
    }

    function updatePriceAndVariant() {
      const variant = findMatchingVariant();
      if (!variant) return;
      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl && variant.price !== undefined) {
        priceEl.textContent = formatMoney(variant.price);
      }
    }

    // Express sells each size *in each flavour* as its own variant, so a
    // flavour can be sold out in one size and available in another. Liquid
    // only knows whether a value is available *somewhere*, so the real
    // combination is worked out here, from the variants JSON, every time the
    // selection changes.
    function isCombinationAvailable(overrides) {
      const selected = Object.assign({}, getSelectedOptions(), overrides);
      return variants.some((variant) => {
        if (!variant.available) return false;
        return optionNames.every((optionName, index) => {
          if (!(optionName in selected)) return true;
          return variant['option' + (index + 1)] === selected[optionName];
        });
      });
    }

    const sizeSelect = variantSelects.querySelector('select[data-option-name="Rozmiar"]');

    function syncFlavorAvailability() {
      // Only flavour cards that drive a variant carry data-option-name; the
      // other collections send the flavour as a line item property, where
      // nothing can be sold out.
      root.querySelectorAll('[data-flavor-radio][data-option-name]').forEach((radio) => {
        const available = isCombinationAvailable({ Smak: radio.value });
        const card = radio.closest('.custom-cake__flavor');
        if (card) card.classList.toggle('custom-cake__flavor--sold-out', !available);
        const status = card && card.querySelector('[data-flavor-status]');
        if (status) status.hidden = available;
        // The chosen one stays clickable even when it sells out, otherwise the
        // radio group would lose its selection and the form its variant.
        radio.disabled = !available && !radio.checked;
      });
    }

    function syncSizeAvailability() {
      if (!sizeSelect) return;
      Array.from(sizeSelect.options).forEach((option) => {
        if (!option.dataset.label) option.dataset.label = option.textContent.trim().replace(/\s+–\s+wyprzedane$/, '');
        const available = isCombinationAvailable({ Rozmiar: option.value });
        const text = available ? option.dataset.label : option.dataset.label + ' – wyprzedane';
        // Rewriting the text on every change would make custom-select.js
        // rebuild its list for nothing, so only a real difference is written.
        if (option.textContent.trim() !== text) option.textContent = text;
        option.disabled = !available && !option.selected;
      });
    }

    function syncAvailability() {
      syncFlavorAvailability();
      syncSizeAvailability();

      const variant = findMatchingVariant();
      const soldOut = !variant || variant.available === false;
      if (soldOutNote) soldOutNote.hidden = !soldOut;
      if (submitButton) submitButton.disabled = soldOut;
    }

    function formatMoney(cents) {
      const amount = (cents / 100).toFixed(2).replace('.', ',');
      return amount + ' zł';
    }

    function updateFlavorInfo(selectedFlavorValue) {
      updateFlavorPhoto(selectedFlavorValue);
      if (!flavorInfo) return;
      flavorInfo.querySelectorAll('[data-flavor-value]').forEach((el) => {
        el.hidden = el.dataset.flavorValue !== selectedFlavorValue;
      });
    }

    // Shows the chosen flavour's cross-section photo under the cake. The URL
    // comes off the radio rather than the thumbnail in the list: that <img> is
    // only 80px wide and would be badly pixelated at gallery size.
    // The flavour photo is a slide. When it appears or disappears the slider
    // has to recount its pages, or its "1 / 2" counter and arrows go stale.
    function syncFlavorSlide(wasHidden) {
      if (wasHidden === flavorPhoto.hidden) return;
      const slider = root.querySelector('slider-component');
      // Only a slider Dawn actually wired up (it found its "Slider-…" list) can
      // recount. And whatever happens, a slider problem must never abort this
      // init — the add-to-cart handler is bound further down.
      if (!slider || !slider.slider || typeof slider.resetPages !== 'function') return;
      try {
        slider.resetPages();
      } catch (error) {
        console.warn('Flavour slide: slider recount failed', error);
      }
    }

    function updateFlavorPhoto(selectedFlavorValue) {
      if (!flavorPhoto || !flavorPhotoImage) return;
      const wasHidden = flavorPhoto.hidden;

      let source = null;
      root.querySelectorAll('[data-flavor-radio]').forEach((radio) => {
        if (radio.value === selectedFlavorValue) source = radio.dataset.flavorImageSrc || null;
      });

      // A flavour without a photo hides the slot rather than leaving a broken
      // image or a stale photo from the previously selected flavour.
      if (!source) {
        flavorPhoto.hidden = true;
        flavorPhotoImage.removeAttribute('src');
        flavorPhotoImage.alt = '';
        syncFlavorSlide(wasHidden);
        return;
      }

      flavorPhotoImage.src = source;
      flavorPhotoImage.alt = selectedFlavorValue || '';
      flavorPhoto.hidden = false;
      syncFlavorSlide(wasHidden);
    }

    // Colour photos come from the section's "Zdjęcie koloru" blocks. A colour
    // without its own photo falls back to the product's main photo rather
    // than keeping the previous colour's picture.
    const mainImage = root.querySelector('[data-express-main-image]');
    const colorImagesScript = root.querySelector('[data-express-color-images]');
    let colorImages = {};
    if (colorImagesScript) {
      try {
        colorImages = JSON.parse(colorImagesScript.textContent) || {};
      } catch (error) {
        console.warn('Colour photos: invalid JSON', error);
      }
    }

    function updateColorImage(colorValue) {
      if (!mainImage) return;
      const entry = colorImages[colorValue];
      const data = entry || {
        src: mainImage.dataset.defaultSrc,
        srcset: mainImage.dataset.defaultSrcset,
        width: mainImage.dataset.defaultWidth,
        height: mainImage.dataset.defaultHeight,
        alt: mainImage.dataset.defaultAlt,
      };
      if (!data.src || mainImage.getAttribute('src') === data.src) return;

      if (data.width) mainImage.width = data.width;
      if (data.height) mainImage.height = data.height;
      mainImage.srcset = data.srcset || '';
      mainImage.src = data.src;
      mainImage.alt = data.alt || '';

      // The colour photo is the first slide; bring it into view if the
      // shopper had swiped further along.
      const slides = root.querySelector('[id^="Slider-"]');
      if (slides && slides.scrollLeft > 0) slides.scrollTo({ left: 0, behavior: 'smooth' });
    }

    variantSelects.addEventListener('change', (event) => {
      updatePriceAndVariant();
      syncAvailability();
      if (event.target.dataset.optionName === 'Smak') {
        updateFlavorInfo(event.target.value);
      }
      if (event.target.dataset.optionName === 'Kolor') {
        updateColorImage(event.target.value);
      }
    });

    const flavorRadios = root.querySelectorAll('[data-flavor-radio]');
    flavorRadios.forEach((radio) => {
      radio.addEventListener('change', () => updateFlavorInfo(radio.value));
    });

    // The server already rendered the selected colour's photo; this only
    // catches a browser restoring a different checked colour after reload.
    // Pâtissière colours are plain radios outside variant-selects.
    root.querySelectorAll('[data-color-radio]').forEach((radio) => {
      radio.addEventListener('change', () => updateColorImage(radio.value));
    });

    const checkedColorRadio = root.querySelector('[data-color-radio]:checked');
    const initialKolor = getSelectedOptions()['Kolor'] || (checkedColorRadio && checkedColorRadio.value);
    if (initialKolor) updateColorImage(initialKolor);

    const initialSmak = getSelectedOptions()['Smak'];
    if (initialSmak) {
      updateFlavorInfo(initialSmak);
    } else {
      const checkedFlavorRadio = root.querySelector('[data-flavor-radio]:checked');
      if (checkedFlavorRadio) updateFlavorInfo(checkedFlavorRadio.value);
    }

    syncAvailability();

    if (!form) return;

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      if (errorWrapper) errorWrapper.hidden = true;

      const variant = findMatchingVariant();
      if (!variant) {
        showError('Wybierz wszystkie opcje produktu.');
        return;
      }

      if (variant.available === false) {
        showError('Ten smak w tym rozmiarze jest chwilowo wyprzedany — wybierz inny smak albo rozmiar.');
        return;
      }

      if (dateInput && !dateInput.value) {
        showError('Wybierz datę odbioru.');
        dateInput.focus();
        return;
      }

      const dateIssue = pickupDateIssue();
      if (dateIssue) {
        showError(dateIssue);
        showDateIssue(dateIssue);
        dateInput.focus();
        return;
      }

      const properties = {};
      form.querySelectorAll('[name^="properties["]').forEach((field) => {
        const key = field.name.match(/properties\[(.+)\]/)[1];
        if (field.type === 'checkbox' || field.type === 'radio') {
          if (field.checked) properties[key] = field.value;
          return;
        }
        if (field.value) properties[key] = field.value;
      });

      const quantity = quantityInput ? Math.max(1, parseInt(quantityInput.value, 10) || 1) : 1;
      const items = [{ id: variant.id, quantity: quantity, properties: properties }];

      if (topperCheckbox && topperCheckbox.checked && topperVariantId) {
        items.push({ id: Number(topperVariantId), quantity: quantity });
      }

      if (submitButton) submitButton.disabled = true;

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then((response) => response.json().then((data) => ({ ok: response.ok, data: data })))
        .then(({ ok, data }) => {
          if (!ok) {
            throw new Error(data.description || data.message || 'Nie udało się dodać produktu do koszyka.');
          }
          window.location.href = window.Shopify.routes.root + 'cart';
        })
        .catch((error) => {
          showError(error.message);
        })
        .finally(() => {
          if (submitButton) submitButton.disabled = false;
        });
    });

    function showError(message) {
      if (!errorWrapper || !errorMessage) return;
      errorMessage.textContent = message;
      errorWrapper.hidden = false;
    }
  }
})();
